





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { MotivoCancelamento } from '@/models/MotivoCancelamento'
import { SaveMotivosDeCancelamentoUseCase } from '@/usecases/venda/SaveMotivosDeCancelamentoUseCase'

@Component

export default class DialogoDeEdicaoDeMotivosDeCancelamento extends Vue {
	@Prop({type: Object}) motivo?: MotivoCancelamento
	saveMotivosDeCancelamentoUseCase = new SaveMotivosDeCancelamentoUseCase()
	motivoEmEdicao: string | undefined
	mostra = false
	salvando = false

	mostrar() {
		this.onChangeMotivo()
		this.mostra = true
	}

	esconder() {
		this.motivoEmEdicao = undefined
		this.mostra = false
		this.$emit('esconder')
	}

	async salvar() {
		if (!this.motivo) return
		if (!this.motivoEmEdicao) return

		try {
			this.salvando = true

			this.editarMotivo()

			const motivoSalvo = this.motivo.id
				? await this.saveMotivosDeCancelamentoUseCase.update(this.motivo)
				: await this.saveMotivosDeCancelamentoUseCase.create(this.motivo)

			this.motivo.id
			this.$emit('create', motivoSalvo)
			this.mostra = false
			AlertModule.setSuccess('Motivo salvo com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.motivo.motivo = ""
		}
	}

	editarMotivo() {
		if(this.motivo && this.motivoEmEdicao) this.motivo.motivo = this.motivoEmEdicao
	}

	@Watch('motivo')
	onChangeMotivo() {
		if(this.motivo){
			this.motivoEmEdicao = this.motivo.motivo
		}
	}

}
